export class GetDaysDifference {
    constructor() {
        this.handle = async (startDate, endDate) => {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const difference = end.getTime() - start.getTime();
            if (start > end) {
                return 0;
            }
            return Math.floor(difference / (1000 * 3600 * 24));
        };
    }
}
